import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppOfflineStore } from '../app.offlineService';
import { BaseSvcService } from './config/base-svc.service';
import {
  HandleError,
  HttpErrorHandlerService,
} from './config/http-error-handler.service';
import { SessionService } from './session.service';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { IQuestionsWithAnswersResponse } from '../interfaces/questionManagement';
export interface IGetFlashcardPayload {
  LoggedInUser: string;
  SessionLanguageTypeCode: string;
  SubjectId?: number | null;
  FlashcardID: string | null;
  ScreenName: string;
}
export interface ICreateUpdateApplicableFlashCardPayload {
  LoggedInUser: string;
  ErrorMessage: string;
  UDTFlashcardApplicableCourseCategory: IFlashcardApplicableCourseCategoryList[];
  UDTFlashcardApplicableCourse: IFlashcardApplicableCourseList[];
}

export interface IFlashcardApplicableCourseCategoryList {
  FlashcardID: string;
  CourseCategoryTypeCode: string;
  SelectedIND: string;
}

export interface IFlashcardApplicableCourseList {
  FlashcardID: string;
  CourseID: number;
  // PreviouslyAskedIND: string;
  SelectedIND: string;
  FlashcardDifficultyLevelTypeCode:string
}
export interface IGetFlashcardsApplicablePayload {
  CourseID: number | null;
  DeletedInd: string;
  LoggedInUser: string;
  FlashcardID: string | null;
  ScreenName: string;
  SessionLanguageTypeCode: string | null;
  SubjectId: number | null;
  SelectedInd: string;
}
export interface IGetFlashcardCategoryApplicablePayload {
  LoggedInUser: string;
  SubjectId: number | null;
  FlashcardID: string | null;
  SelectedInd: string;
}

export interface IGetPathPayload {
  LoggedInUserID: string;
  SubjectId: number | null;
  Screenname: string;
}

@Injectable({
  providedIn: 'root',
})
export class FlashCardManagementService {
  private handleError: HandleError;
  public url: string;
  public options;
  private nextButtonFlagSubject = new Subject<boolean>();
  nextButtonFlag$ = this.nextButtonFlagSubject.asObservable();
  private refreshSubject = new Subject<boolean>();
  refreshFlag$ = this.refreshSubject.asObservable();
  refreshQuestionList(value: boolean) {
    this.refreshSubject.next(value);
  }
  constructor(
    private http: HttpClient,
    public session: SessionService,
    private appserv: AppOfflineStore,
    public httpErrorHandler: HttpErrorHandlerService,
    private config: BaseSvcService
  ) {
    this.handleError = httpErrorHandler.createHandleError('HeroesService');
    this.url = this.config.activeURL;
    this.options = this.config._httpoption;
  }

  getFlashCards$(data: Partial<IGetFlashcardPayload>): Observable<any[]> {
    data.LoggedInUser = this.session.getUser();
    data.SessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post(`${this.url}api/GetFlashCard`, data, this.options)
      .pipe(
        map((response: any) => {
          // Process the response data here (optional)

          return response.result; // Return the processed data
        })
      );
  }

  createUpdateApplicableFlashCard$(
    data: Partial<ICreateUpdateApplicableFlashCardPayload>
  ): Observable<any> {
    data.LoggedInUser = this.session.getUser();
    return this.http.post(
      `${this.url}api/InsertOrUpdateFlashcardApplicableCourse`,
      data,
      this.options
    );
  }

  getFlashCardApplicableCourseCategory$(
    data: Partial<IGetFlashcardCategoryApplicablePayload>
  ): Observable<any> {
    data.LoggedInUser = this.session.getUser();
    return this.http
      .post(
        `${this.url}api/GetFlashcardApplicableCourseCategory`,
        data,
        this.options
      )
      .pipe(
        map((e: any) => {
          return e.result;
        })
      );
  }
  getFlashcardApplicableCourse$(
    data: Partial<IGetFlashcardsApplicablePayload>
  ): Observable<any> {
    data.LoggedInUser = this.session.getUser();
    // data.SessionLanguageTypeCode = this.appserv.userlanuage;
    data.SessionLanguageTypeCode = null;
    return this.http
      .post(`${this.url}api/GetFlashcardApplicableCourse`, data, this.options)
      .pipe(
        map((e: any) => {
          return e.result;
        })
      );
  }
  getPath$(data: Partial<IGetPathPayload>): Observable<string> {
    data.LoggedInUserID = this.session.getUser();
    return this.http.post(`${this.url}api/GetPath`, data, this.options).pipe(
      map((res: any) => {
        return res.Data;
      })
    );
  }

  processData(data: IQuestionsWithAnswersResponse[]) {
    const questionMap: { [key: string]: any } = {};

    data.forEach((item) => {
      const questionId = item.Question_ID;

      if (!questionMap[questionId]) {
        questionMap[questionId] = {
          Question_ID: item.Question_ID,
          Question_Template_ID: item.Question_Template_ID,
          Language_Type_Code: item.Language_Type_Code,
          Recommended_Response_Time_Type_Code:
            item.Recommended_Response_Time_Type_Code,
          Recommended_Response_Time_Type_Name:
            item.Recommended_Response_Time_Type_Name,
          Question_Gk_Type_Code: item.Question_Gk_Type_Code,
          Question_Gk_Type_Name: item.Question_Gk_Type_Name,
          Question_Status_Type_Code: item.Question_Status_Type_Code,
          Question_Status_Type_Name: item.Question_Status_Type_Name,
          Location_ID: item.Location_ID,
          Location_Name: item.Location_Name,
          Multi_Part_Question_Ind: item.Multi_Part_Question_Ind,
          Allow_Translation_Ind: item.Allow_Translation_Ind,
          Comment_Text: item.Comment_Text,
          Question_Text: item.Question_Text,
          Question_Search_Text: item.Question_Search_Text,
          Created_By: item.Created_By,
          Creation_Date: item.Creation_Date,
          AllAnswers: [],
        };
      }

      // Add the answer to the AllAnswers array
      questionMap[questionId].AllAnswers.push({
        Answer_Type_Code: item.Answer_Type_Code,
        Answer_Type_Name: item.Answer_Type_Name,
        Answer_Choice_ID: item.Answer_Choice_ID,
        Right_Answer_Ind: item.Right_Answer_Ind,
        Answer_Choice_Text: item.Answer_Choice_Text,
      });
    });

    // Return an array of the grouped questions
    return Object.values(questionMap);
  }
  updateFlashCardDisplayOrder$(
    flashcards: { FlashCardID: string; DisplayOrder: number }[]
  ): Observable<any> {
    const payload = {
      LoggedInUser: this.session.getUser(),
      UDTFlashCard: flashcards,
    };

    return this.http.post(
      `${this.url}api/UpdateFlashCardOrder`,
      payload,
      this.options
    );
  }

  // #region Refresh Logic
  updateNextButtonFlag(value: boolean) {
    this.nextButtonFlagSubject.next(value);
  }
}
